//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "work-order-cell",
    props: {
        item: {
            required: true,
            type: Object
        }
    },
}
